export const FEEDBACK_INVITATION_STORAGE_PREFIX = "venaqqi_feedback_invitation_state_v2";
export const GUEST_FEEDBACK_AUDIENCE = "guest";
export const FEEDBACK_PAUSE_AFTER_SUBMISSION_MS = 30 * 24 * 60 * 60 * 1000;
export const LONG_INTERVAL_MIN_MS = 3 * 60 * 60 * 1000;
export const LONG_INTERVAL_MAX_MS = 4 * 60 * 60 * 1000;

export const feedbackAudienceForUser = userId => userId ? `user:${userId}` : GUEST_FEEDBACK_AUDIENCE;
const storageKey = audience => `${FEEDBACK_INVITATION_STORAGE_PREFIX}:${encodeURIComponent(audience)}`;
export const nextLongInterval = (random = Math.random) => random() < 0.5 ? LONG_INTERVAL_MIN_MS : LONG_INTERVAL_MAX_MS;
const initialState = random => ({ version: 2, openCount: 0, rejectionCount: 0, presentationCount: 0, nextOpenAt: null, accumulatedOpenMs: 0, nextLongIntervalMs: nextLongInterval(random), checkpointAt: null, pauseUntil: null, lastPresentationAt: null, lastFeedbackAt: null });

export const readFeedbackInvitationState = (audience, random = Math.random) => {
  if (!audience) return initialState(random);
  try { return { ...initialState(random), ...JSON.parse(localStorage.getItem(storageKey(audience)) || "null") }; }
  catch { return initialState(random); }
};
const write = (audience, state) => { try { localStorage.setItem(storageKey(audience), JSON.stringify(state)); } catch {} return state; };
const checkpoint = (state, now) => {
  if (state.checkpointAt == null) return state;
  // Una respuesta completa abre una pausa real: el tiempo dentro de esos 30 días
  // no deja una invitación lista para aparecer inmediatamente al terminarla.
  const countFrom = state.pauseUntil ? Math.max(state.checkpointAt, state.pauseUntil) : state.checkpointAt;
  return { ...state, accumulatedOpenMs: state.accumulatedOpenMs + Math.max(0, now - countFrom), checkpointAt: now };
};

export const registerFeedbackAppOpen = (audience, now = Date.now(), random = Math.random) => {
  const state = readFeedbackInvitationState(audience, random);
  return write(audience, { ...state, openCount: state.openCount + 1, checkpointAt: now });
};
export const checkpointFeedbackOpenTime = (audience, now = Date.now(), endSession = false) => {
  const state = checkpoint(readFeedbackInvitationState(audience), now);
  return write(audience, { ...state, checkpointAt: endSession ? null : state.checkpointAt });
};
export const resumeFeedbackOpenTime = (audience, now = Date.now()) => {
  const state = readFeedbackInvitationState(audience);
  return write(audience, { ...state, checkpointAt: now });
};
export const feedbackInvitationEligibility = (audience, now = Date.now()) => {
  const state = checkpointFeedbackOpenTime(audience, now);
  if (state.pauseUntil && now < state.pauseUntil) return { eligible: false, reason: "paused", state };
  if (state.nextOpenAt != null && state.openCount >= state.nextOpenAt) return { eligible: true, reason: "openings", state };
  if (state.accumulatedOpenMs >= state.nextLongIntervalMs) return { eligible: true, reason: "hours", state };
  return { eligible: false, reason: null, state };
};
export const recordAutomaticFeedbackInvitationPresented = (audience, now = Date.now(), random = Math.random) => {
  const state = checkpoint(readFeedbackInvitationState(audience, random), now);
  return write(audience, { ...state, presentationCount: state.presentationCount + 1, nextOpenAt: null, accumulatedOpenMs: 0, nextLongIntervalMs: nextLongInterval(random), checkpointAt: now, lastPresentationAt: now });
};
export const recordAutomaticFeedbackRejection = audience => {
  const state = readFeedbackInvitationState(audience);
  const rejectionCount = state.rejectionCount + 1;
  const gap = rejectionCount <= 3 ? [3, 4, 5][rejectionCount - 1] : Math.min(5 + (rejectionCount - 3), 8);
  return write(audience, { ...state, rejectionCount, nextOpenAt: state.openCount + gap });
};
export const recordCompletedFeedback = (audience, { stars, comments }, now = Date.now()) => {
  if (!(Number(stars) >= 1 && Number(stars) <= 5) || !String(comments || "").trim()) return false;
  const state = readFeedbackInvitationState(audience);
  write(audience, { ...state, pauseUntil: now + FEEDBACK_PAUSE_AFTER_SUBMISSION_MS, nextOpenAt: null, accumulatedOpenMs: 0, checkpointAt: state.checkpointAt == null ? null : now, lastFeedbackAt: now });
  return true;
};
